import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Domain, sortDomains } from '@engagement/core/store/domain';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';

import { CngFacade, HttpService, Logger } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  private readonly _domains$: Subject<Domain[]> = new Subject();
  readonly domains: Observable<Domain[]> = this._domains$.asObservable();

  constructor(private readonly logger: Logger, private readonly http: HttpService) {
    this.logger = this.logger.forSource(`DomainService`);
  }

  loadDomains(rehydrate: boolean = false): Observable<Domain[]> {
    return this.http
      .cache(rehydrate)
      .get<any>(CngFacade.PROTECTED__ENGAGEMENT + '/domains', {
        observe: 'response',
      })
      .pipe(
        catchError((response: HttpResponse<any>) => {
          if (response.status === 401) {
            return throwError(() => 'commons:session.invalid_session');
          }
          return throwError(() => 'commons:session.unknow_error');
        }),
        map(response => {
          let { body } = response;
          const domains = body as unknown as Domain[];
          domains.sort(sortDomains);
          this._domains$.next(domains);
          return domains;
        })
      );
  }
}
